<template>
  <div v-if="showInstallButton" class="install-app-wrapper">
    <v-btn
      class="btn white--text mb-12 mr-n2"
      color="blue darken-2"
      height="2rem"
      fixed
      absolute
      bottom
      right
      rounded
      @click="installPWA()"
    >
      <v-icon left>mdi-download</v-icon>
      Instalar App
    </v-btn>

    <v-bottom-sheet v-model="sheet">
      <div class="d-flex align-center justify-center pb-6">
        <v-card class="card pa-3" color="white" max-width="75%" light>
          <div class="d-flex flex-column text-center">
            <div>Instale o nosso aplicativo</div>

            <div>
              No <span class="font-weight-bold">navegador</span>, clique em
              compartilhar
              <v-icon color="blue" small>mdi-export-variant</v-icon> e depois em
              <span class="font-weight-bold">"Adicionar à tela de início"</span>
            </div>

            <v-btn class="btn" color="blue" text @click="sheet = false">
              Agora não
            </v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "InstallApp",

  data() {
    return {
      deferredPrompt: null,
      isAndroid: false,
      isIos: false,
      isSafari: false,
      showInstallButton: false,
      sheet: false,
    };
  },

  mounted() {
    this.detectPlatform();

    // Se já estiver instalado, não mostra o botão
    if (this.isInStandalone()) {
      this.showInstallButton = false;
      return;
    }

    // Android
    if (this.isAndroid) {
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        this.deferredPrompt = e;
        this.showInstallButton = true;
      });
    }

    // iOS Safari
    if (this.isIos && this.isSafari) {
      this.showInstallButton = true;
    }
  },

  methods: {
    detectPlatform() {
      const ua = window.navigator.userAgent.toLowerCase();
      this.isAndroid = ua.includes("android");
      this.isIos = /iphone|ipad|ipod/.test(ua);
      this.isSafari = /^((?!chrome|android).)*safari/i.test(
        window.navigator.userAgent
      );
    },

    // Detecta se já está instalado no modo standalone
    isInStandalone() {
      // iOS Safari
      if ("standalone" in window.navigator && window.navigator.standalone) {
        return true;
      }
      // Android Chrome / Outros navegadores PWA
      if (window.matchMedia("(display-mode: standalone)").matches) {
        return true;
      }
      return false;
    },

    installPWA() {
      if (this.isAndroid && this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            this.deferredPrompt = null;
            this.showInstallButton = false;
          }
        });
      } else if (this.isIos && this.isSafari) {
        this.sheet = true;
      }
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
